import { BaseLoopBackApi } from '../sdk/services/core/base.service';
import { ServerProvider } from '../providers/server-provider';
import { LoopBackFilter } from '../sdk';
import { BaseViewComponent } from './baseViewComponent';
import { LoadingComponent } from './loadingComponent';
import { Observable } from 'rxjs';

/**
 * Clase que proporciona un scroll infinito
 */
export abstract class InfiniteScrollComponent extends BaseViewComponent {
    //servicio a usar para buscar
    protected serviceAPI: BaseLoopBackApi;

    //listado de items
    protected listItems: Array<any>;
    protected listItemsLocalSearch: Array<any>;

    //carga datos de forma local
    protected isLocalData: boolean = false;

    //fields
    protected filterFields: any = ["id", "name"];

    //where filter
    protected filterWhere: any = {};

    //include filter 
    protected filterInclude: any;

    //order filter
    protected filterOrder:any;

    //tamaño paginacion
    protected filterLimit: number = 20;
2
    //variable que indica si hay mas elementos que mostrar en el scroll
    protected isMoreItemsScroll: boolean = true;

    //palabras a buscar en la barra de busqueda
    protected strSearchBar: string;

    //indica si la barra de busqueda esta visible o no
    protected isShowSearchBar: boolean = false;

    //indica si la barra de filtros esta visible o no
    protected isShowFilterBar: boolean = false;

    protected strFilterBar: string = "";

    //comprueba si hay items o no
    protected isNoItems: boolean = false;

    //indica si se realiza una consulta como OpenErpApp o no
    protected isOpenErpApp: boolean = false;

    
    //protected loadingCtrl: LoadingController

    /**
     * 
     * @param service servicio API a usar
     */
    constructor(
        service: BaseLoopBackApi
    ) {

        super();
        
        this.serviceAPI = service;

        //inicializar array
        this.listItems = [];

    }

    /**
     * Function abstracta que recupera el LoadingController
     */
    public abstract getLoadingComponent():LoadingComponent;

    protected ionViewDidLoad(){

        super.ionViewDidLoad();

        //cargar datos al inicio
        this.isMoreItemsScroll = true;
        
        this.listItems = [];

        //filtro de busqueda por nombre
        if(this.strSearchBar && this.strSearchBar.length > 2){
            this.filterWhere.name = {"ilike": this.strSearchBar };
        }

        this.isNoItems = false;

        //modal de cargando
        let currentLoadingCmp:LoadingComponent = this.getLoadingComponent();
        if(currentLoadingCmp){
            currentLoadingCmp.create({content: 'Cargando', showBackdrop: false});
        }
        
        this.loadDataApi().subscribe((allData: any[]) => {
            //insertar items en lista
            this.listItems = allData;

            console.log("allData: ", allData);

            //mira si hay items o no
            
            this.isNoItems = (!this.listItems || this.listItems.length==0);

            if(currentLoadingCmp){
                //cerrar modal
                currentLoadingCmp.dismiss();
            }
            
            console.log(this.listItems);
        });
        
    }

    /**
   * Pide datos a la nube
   */
    protected loadDataApi(): Observable<any> {
        
        if(this.serviceAPI){
            //pide al servicio datos al servicio
            let jsonFind:LoopBackFilter = {
                "fields": this.filterFields,
                "where": this.filterWhere,
                "limit": this.filterLimit,
                "include": this.filterInclude,
                "skip": this.listItems.length,
                "order": this.filterOrder
            };

            return ServerProvider.find(this.serviceAPI, jsonFind, this.isOpenErpApp);
        }else{
            return new Observable(data => {});
        }
        

    }


    /**
     * Recarga la vista actual
     * @param refresher evento refresher
     */
    public doRefresh(refresher) {
        
        this.isMoreItemsScroll = true;
        
        this.listItems = [];

        //filtro de busqueda por name
        if(this.strSearchBar && this.strSearchBar.length > 2){
            this.filterWhere.name = {"ilike": this.strSearchBar };
        }

        this.isNoItems = false;

        this.loadDataApi().subscribe((allData: any[]) => {
            //insertar items en lista
            this.listItems = allData;

            //mira si hay items o no
            this.isNoItems = (this.listItems.length==0);

            if(refresher){
                refresher.complete();
            }
        
        });

    }


    /**
   * Carga más items del scroll infinito
   */
    public doInfinite(infiniteScroll) {

        //pide datos a la nube
        this.loadDataApi().subscribe((newItems: any[]) => {
            //insertar items en lista
            this.listItems.push.apply(this.listItems, newItems);

            //comprueba si hay mas elementos que mostrar en el scroll
            if(newItems.length < this.filterLimit){
                this.isMoreItemsScroll = false;
            }

            infiniteScroll.complete();
        });

    }


    /**
    * Evento al escribir algo en el campo de la barra busqueda
    */
    public onInputSearchEvent(inputEvent) {

        //al introducir mas de 3 palabras, buscar
        if ( (this.strSearchBar && this.strSearchBar.length >= 3) || !this.strSearchBar) {
            
            if(this.strSearchBar){
                this.filterWhere.name = {"ilike": this.strSearchBar };
            }else if(this.filterWhere.name){
                delete this.filterWhere.name;
            }
            

            if(!this.isLocalData){
                //buscamos en la nube
            
                //vaciamos lista
                this.listItems = [];
                this.isNoItems = false;

                //pide datos a la nube
                this.loadDataApi().subscribe((allPartners: any[]) => {
                    //insertar items en lista
                    this.listItems = allPartners;

                    console.log("search: ", allPartners);

                    //mira si hay items o no
                    this.isNoItems = (this.listItems.length==0);
                });

            }else{
                //buscamos en local
                if(this.listItemsLocalSearch){
                    
                    //vaciamos la lista
                    this.listItems = [];

                    //recorremos la lista original y buscar por la palabra de la searchBar
                    this.listItemsLocalSearch.forEach(element => {
                        
                        if(element && element.name && element.name.toUpperCase().indexOf(this.strSearchBar.toUpperCase()) > -1 ){
                            //insertar item
                            this.listItems.push(element);
                        }
                    });
                }

            }

        }
    }

    
    /**
     * Al clickar en el boton de la lupa
     * Se muestra o se oculta la barra de búsqueda
     */
    public onClickButtonSearchbar() {
        this.isShowSearchBar = !this.isShowSearchBar;
        this.isShowFilterBar = false;
    }

    /**
     * Activa el modo filtrado de items
     */
    public onClickFilter(){
        this.isShowFilterBar = !this.isShowFilterBar;
        this.isShowSearchBar = false;
    }

    /**
     * Evento al cambio el filterBar del state
     * @param event 
     */
    public onChangeFilterBar(event){
        console.log("onChangeFilterBar", event);

        this.setFilterBar();

        this.ionViewDidLoad();
        
    }

    public setFilterBar(){
        if(this.strFilterBar && this.strFilterBar.length>0){
            this.filterWhere.state = this.strFilterBar;
        }else if(this.filterWhere.state){
            delete this.filterWhere.state;
        }
    }


}


// WEBPACK FOOTER //
// ./src/components/inifiniteScrollComponent.ts